import { toast } from "react-toastify";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5050";

function getToken() {
  return (
    localStorage.getItem("ecoval_token") ||
    sessionStorage.getItem("ecoval_token")
  );
}

async function request(endpoint, options = {}) {
  const token = getToken();

  const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-store",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("ecoval_token");
    localStorage.removeItem("ecoval_user");
    sessionStorage.removeItem("ecoval_token");
    sessionStorage.removeItem("ecoval_user");
    toast.error("Session expired. Please login again.");
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || "Request failed");
  }

  return data;
}

export const http = {
  get: (url) => request(url),

  post: (url, body) =>
    request(url, {
      method: "POST",
      body: body != null ? JSON.stringify(body) : undefined,
    }),

  put: (url, body) =>
    request(url, {
      method: "PUT",
      body: body != null ? JSON.stringify(body) : undefined,
    }),

  patch: (url, body) =>
    request(url, {
      method: "PATCH",
      body: body != null ? JSON.stringify(body) : undefined,
    }),

  delete: (url) => request(url, { method: "DELETE" }),
};

export { BASE_URL };
